import Search from "antd/lib/input/Search";
import React from "react";
import Link from "../../../core/ui/components/Link";
import { IRouter } from "../../../runtime/Router";
import { TSearchCriteriaFilter } from "../../model/SearchCriteria";

interface Props {
  navigator: IRouter;
  placeholder: string;
  searchActionLabel: string;
  advancedSearchHref: string;
  advancedSearchLabel: string;
  onSearch?(query: TSearchCriteriaFilter, reset?: boolean): any;
  defaultValue?: string;
  advancedSearchEnabled?: boolean;
}

const HeroSearchBar: React.FC<Props> = ({
  navigator,
  placeholder,
  searchActionLabel,
  advancedSearchHref,
  advancedSearchLabel,
  defaultValue,
  onSearch,
  advancedSearchEnabled = true
}) => {
  return (
    <div className="text-align-right hero-search-input">
      <Search
        placeholder={placeholder}
        allowClear
        enterButton={searchActionLabel}
        size="large"
        onSearch={(value) =>
          onSearch?.(
            {
              phrase: value
            },
            false
          )
        }
        defaultValue={defaultValue}
      />
      {advancedSearchEnabled && (
        <Link
          router={navigator}
          path={advancedSearchHref}
        >{`${advancedSearchLabel}...`}</Link>
      )}
    </div>
  );
};

export default HeroSearchBar;
